// <s-view-toggle> — remembers the shopper's grid/list choice on collection pages.
// Wraps the view radios; restores the saved value on connect and saves it on change.
// Storage failures (private mode, blocked storage) fall back to the default view. One component per file.
const STORAGE_KEY = "gazola:collection-view";

class SViewToggle extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();

    let saved = null;
    try {
      saved = window.localStorage.getItem(STORAGE_KEY);
    } catch {
      saved = null;
    }
    if (saved) {
      const radio = this.querySelector(`input[type="radio"][value="${CSS.escape(saved)}"]`);
      if (radio) radio.checked = true;
    }

    this.addEventListener("change", (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.type !== "radio" || !target.checked) return;
      try {
        window.localStorage.setItem(STORAGE_KEY, target.value);
      } catch {
        // Storage unavailable; the choice still applies for this page.
      }
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get("s-view-toggle")) {
  customElements.define("s-view-toggle", SViewToggle);
}
